import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../EventTrackingConstants';
import { AnalyticsTypes, RedirectLabels } from '../../middleware/google-analytics';
import { ActionTypes } from '../constants';

export const onServiceEmailClick = () => ({
    type: ActionTypes.CLICK_SERVICE_EMAIL,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Service Email',
            data: {
                Section: TARGETS.SERVICE_BANNER,
                Component: TARGETS.SERVICE_EMAIL,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click service email',
            },
        },
    },
});

export const onServicePhoneClick = () => ({
    type: ActionTypes.CLICK_SERVICE_PHONE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Service Phone',
            data: {
                Section: TARGETS.SERVICE_BANNER,
                Component: TARGETS.SERVICE_PHONE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click service phone',
            },
        },
    },
});

export const onSeoLinkClick = ({ action, Component, Element }) =>
    trackFooterLinkClicks({
        action,
        Section: TARGETS.ZOCDOC_FOOTER,
        Component,
        Element,
    });

export const onLegalLinkClick = ({ action, Component, Element }) =>
    trackFooterLinkClicks({
        action,
        Section: TARGETS.LEGAL_FOOTER,
        Component,
        Element,
    });

const trackFooterLinkClicks = ({
    action, Section, Component, Element,
}) => ({
    type: ActionTypes.TRACK_PAGE_FOOTER_LINK_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action,
            data: {
                Section,
                Component,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: action ? action.toLowerCase() : '',
            },
        },
    },
});

const trackGetAppPanelFactory = Element => () => ({
    type: ActionTypes.TRACK_TEXT_ME_THE_APP_BUTTON_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: `Click Text Me The App ${Element}`,
            data: {
                Section: TARGETS.GET_ZOCDOC_APP_PANEL,
                Component: TARGETS.TEXT_ME_THE_APP,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: `Click ${Element}`,
            },
        },
    },
});

export const trackClickTextAppLink = trackGetAppPanelFactory('SendLinkToDownloadApp');
export const trackClickAppStore = trackGetAppPanelFactory('AppStore');
export const trackClickGooglePlay = trackGetAppPanelFactory('GooglePlay');
export const trackClickPhoneField = trackGetAppPanelFactory('PhoneField');

export const trackTypePhoneNumber = number => ({
    type: ActionTypes.TRACK_TEXT_ME_THE_APP_BUTTON_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Type Text Me The App PhoneNumber',
            label: number,
            data: {
                Section: TARGETS.GET_ZOCDOC_APP_PANEL,
                Component: TARGETS.TEXT_ME_THE_APP,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: 'PhoneNumber',
                Initiator: EVENT_INITIATORS.USER,
                EventDetails: { Value: number },
                EventAction: 'Type PhoneNumber',
            },
        },
    },
});

const trackFindADoctorBy = (Component, element) => ({
    type: ActionTypes.TRACK_FIND_A_DOCTOR_BY_LINK_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Find A Doctor By Link',
            data: {
                Section: TARGETS.FIND_A_DOCTOR_BY,
                Component,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: element,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: `Click ${element} Link`,
            },
        },
    },
});

export const onKnowledgeBaseClick = () => ({
    type: ActionTypes.TRACK_KNOWLEDGE_BASE_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Knowledge Base',
            data: {
                Section: TARGETS.KNOWLEDGE_BASE_FOOTER,
                Component: TARGETS.PATIENT_KNOWLEDGE_BASE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.KNOWLEDGE_BASE_FOOTER,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'Click Knowledge Base',
                Redirect: RedirectLabels.External,
            },
        },
    },
});

export const trackClickCity = ev => {
    return trackFindADoctorBy('City', ev.currentTarget.getAttribute('data-filter-name'));
};
export const trackClickSpecialty = ev => {
    return trackFindADoctorBy('Specialty', ev.currentTarget.getAttribute('data-filter-name'));
};
export const trackClickInsurance = ev => {
    return trackFindADoctorBy('Insurance', ev.currentTarget.getAttribute('data-filter-name'));
};
export const trackFindADoctorSearch = ev => {
    const element = ev.currentTarget.getAttribute('data-filter-name');
    return trackFindADoctorBy(element, element);
};

export const trackListPracticeClick = () => ({
    type: ActionTypes.TRACK_LIST_PRACTICE_BUTTON_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click List Practice Button',
            data: {
                Section: TARGETS.LIST_PRACTICE_PANEL,
                Component: TARGETS.LIST_PRACTICE_CTALINK,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: 'ListYourPractice',
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'Click ListYourPractice Button',
                Redirect: RedirectLabels.Internal,
            },
        },
    },
});

export const trackCheckOurCareersPage = () => ({
    type: ActionTypes.TRACK_CHECK_OUR_CAREERS_PAGE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Check Our Careers Page',
            data: {
                Section: TARGETS.CAREERS_PANEL,
                Component: TARGETS.CAREERS_BUTTON,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.CAREERS_BUTTON,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click check out career page',
                Redirect: RedirectLabels.Internal,
            },
        },
    },
});

export const trackJoinPartnersClick = () => ({
    type: ActionTypes.TRACK_JOIN_PARTNERS_BUTTON_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Join Partners Button',
            data: {
                Section: TARGETS.JOIN_PARTNERS_PANEL,
                Component: TARGETS.JOIN_PARTNERS_CTALINK,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: 'JoinPartners',
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'Click Join us and Partners Button',
                Redirect: RedirectLabels.Internal,
            },
        },
    },
});
